import React, { FC } from 'react';
import { RoomLaunchContainer } from './styles';
import { EditingState } from './EditingState';
import { LaunchedState } from './LaunchedState';
import { useRoomLaunch } from './useRoomLaunch';

interface RoomLaunchBlockProps {
  className?: string;
  selectedTags?: string[];
  projectId?: string;
  onRequiredFieldsChange?: (isFilled: boolean) => void;
  onActiveUploadsChange?: (hasActiveUploads: boolean) => void;
}

export const RoomLaunchBlock: FC<RoomLaunchBlockProps> = ({ 
  className, 
  selectedTags = [], 
  projectId,
  onRequiredFieldsChange,
  onActiveUploadsChange
}) => {
  const {
    isVirtualSpaceSelected,
    isRoomLaunched,
    isLoadingPackages,
    uploadedFiles,
    uploadProgress,
    hasActiveUploads,
    isSaveDisabled,
    inputRefs,
    uploadedPlatforms,
    handleFileUpload,
    handleCancelUpload,
    handleSave,
    handleEdit,
  } = useRoomLaunch({
    selectedTags,
    projectId,
    onRequiredFieldsChange,
    onActiveUploadsChange,
  });

  if (!isVirtualSpaceSelected) {
    return null;
  }

  if (isLoadingPackages) {
    return null;
  }

  return (
    <RoomLaunchContainer className={className}>
      {isRoomLaunched ? (
        <LaunchedState
          projectId={projectId}
          uploadedPlatforms={uploadedPlatforms}
          onEdit={handleEdit}
        />
      ) : (
        <EditingState
          uploadedFiles={uploadedFiles}
          uploadProgress={uploadProgress}
          hasActiveUploads={hasActiveUploads}
          isSaveDisabled={isSaveDisabled}
          inputRefs={inputRefs}
          onFileUpload={handleFileUpload}
          onCancelUpload={handleCancelUpload}
          onSave={handleSave}
        />
      )}
    </RoomLaunchContainer>
  );
};import React, { FC } from 'react';
import { RoomLaunchContainer } from './styles';
import { EditingState } from './EditingState';
import { LaunchedState } from './LaunchedState';
import { useRoomLaunch } from './useRoomLaunch';

interface RoomLaunchBlockProps {
  className?: string;
  selectedTags?: string[];
  projectId?: string;
  onRequiredFieldsChange?: (isFilled: boolean) => void;
  onActiveUploadsChange?: (hasActiveUploads: boolean) => void;
}

export const RoomLaunchBlock: FC<RoomLaunchBlockProps> = ({ 
  className, 
  selectedTags = [], 
  projectId,
  onRequiredFieldsChange,
  onActiveUploadsChange
}) => {
  const {
    isVirtualSpaceSelected,
    isRoomLaunched,
    isLoadingPackages,
    uploadedFiles,
    uploadProgress,
    hasActiveUploads,
    isSaveDisabled,
    inputRefs,
    uploadedPlatforms,
    handleFileUpload,
    handleCancelUpload,
    handleSave,
    handleEdit,
  } = useRoomLaunch({
    selectedTags,
    projectId,
    onRequiredFieldsChange,
    onActiveUploadsChange,
  });

  if (!isVirtualSpaceSelected) {
    return null;
  }

  if (isLoadingPackages) {
    return null;
  }

  return (
    <RoomLaunchContainer className={className}>
      {isRoomLaunched ? (
        <LaunchedState
          projectId={projectId}
          uploadedPlatforms={uploadedPlatforms}
          onEdit={handleEdit}
        />
      ) : (
        <EditingState
          uploadedFiles={uploadedFiles}
          uploadProgress={uploadProgress}
          hasActiveUploads={hasActiveUploads}
          isSaveDisabled={isSaveDisabled}
          inputRefs={inputRefs}
          onFileUpload={handleFileUpload}
          onCancelUpload={handleCancelUpload}
          onSave={handleSave}
        />
      )}
    </RoomLaunchContainer>
  );
};